import React from "react";
import { Link } from "react-router-dom";

const Order = () => {
  return (
    <div>
      <h1>Order page</h1>
      <Link to="/">Go Back</Link>
    </div>
  );
};

export default Order;
